import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Container from '@material-ui/core/Container';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import Refresh from '@material-ui/icons/Refresh';
import ThreadForm from './ThreadForm';
import ThreadCard from "./ThreadCard";

const useStyles = makeStyles(theme => ({
  root: {
    background: 'linear-gradient(45deg, #efefff 30%, #efffff 90%)',
  },
  item: {
    background: "#fafaff",
    border: 'solid 1px #e1e1ff',
    borderRadius: 3,
    margin: 3
  },
  error: {
    background: 'linear-gradient(45deg, #f44336 30%, #d32f2f 90%)'
  }
}));

export default function UserPage({ threads, error, getThreads, openThread, showThreadList }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  React.useEffect(() => {
    getThreads();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <Container>
        <Box pt={3} pb={2}>
          <Typography variant="h4">My Board</Typography>
          <ThreadForm />
        </Box>
        <Box pt={2}>
        <Typography variant="h4">最新スレッド</Typography>
        <List>
        {
          threads.slice(-5).reverse().map((item) => {
            return (
              <ThreadCard
                {...item}
                onClick={() => openThread(item.threadId)}
              />
            );
          })
        }
        </List>
        <Button variant='contained' color='primary' onClick={() => showThreadList()}>スレッド一覧</Button>
      </Box>
      </Container>

      <Snackbar
        ContentProps={classes.error}
        anchorOrigin={{vertical: "top", horizontal:"center"}}
        open={open && error}
        onClose={handleClose}
      >
        <SnackbarContent
          className={classes.snackbar}
          message={
            <div>
              <Typography variant="h6">threads</Typography>
              <Typography variant="body1">{error.status} ({error.statusText})</Typography>
            </div>
          }
          action={
            <IconButton onClick={() => window.location.reload(true)}>
              <Refresh />
            </IconButton>
          }
        />
      </Snackbar>
    </div>
  );
}
